/**
 * @author PoornaChandu
 * @description 
 */
import React, {useState,useEffect,useRef } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import axios from 'axios';
import { connect } from 'react-redux';
import localStorage from '../../../utils/localStorage';
import ReactEcharts from '../../Dashboard/Utils/Echarts/Echarts';
import { getGraphData } from '../apiCalls';
import { Radio, Select, DatePicker, Modal, Button, Form, Input, message } from 'antd';
import { constant,constants } from '../Utils/constants';
import { CreateObservation, getObservationList, getUsersList } from '../ChartCalls';
import TableComponent from '../Widget/Table';
import { 
  API_FILE, 
  IPAddress, REPORTS } from '../../../commons/api';
const { RangePicker } = DatePicker;
const { Option } = Select;
const color = [
  'orange',
  'tomato',
  'steelblue',
  'green',
  'pink',
  'voilet',
  'yellow',
  'red',
  'blue',
  'gray'
];
const AllGraphView = (props) => {
  dayjs.extend(utc);
  // const [selectedInterval, setSelectedInterval] = useState(props.payload?.Interval || '');
  const operatorList = props.OperatorList || [];
  const frequencyList = constants?.frequencyList || [];
  const [selectedOperators, setSelectedOperators] = useState(props.payload?.Operator || '');
  const [payload, setPayload] = useState(props.payload || {});
  const [json, setJson] = useState([]);
  const [codeType,setCodeType] = useState(props.CodeType || 'Device');
  const [selectedName , setSelectedName] = useState(props && props.selectedName ? props.selectedName : ''); 
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [graphType, setGraphType] = useState('line');
  const [reportName,setReportName] = useState('');
  const [option, setOption] = useState({});
  const [celd, setCeld] = useState({});
  const [UsersList, setUsersList] = useState({});
  const [selectedShareType, setSelectedShareType] = useState('');
  const [visible, setVisible] = useState(false);
  const fromDate = dayjs(payload.FromDate).isValid() ? dayjs(payload.FromDate).utc().local() : null;
  const toDate = dayjs(payload.ToDate).isValid() ? dayjs(payload.ToDate).utc().local() : null;
  // const [observationList, setObservationList] = useState([]);
  const observeRef = useRef();
  useEffect(() =>{
    setReportName(reportName);
    generateData(payload);
  },[reportName,payload]);
  useEffect(() => {
    const fetchData = async () => {
      await generateData(payload);
      const users = await getUsersList();
      const observations = await getObservationList();
      setUsersList(users);
      props.ObservationList(observations);
    };
    fetchData();
  }, [payload]);
  useEffect(() => {
    if (props.payload !== payload) {
      setPayload(props.payload);
      generateData(props.payload);
    }
    if (selectedName !== props.selectedName) {
      setSelectedName(props.selectedName);
    }
    if (codeType !== props.CodeType) {
      setCodeType(props.CodeType);
    }
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.payload, props.translationCache ,props.selectedName ,props.CodeType]);
  const generateData = async (currentPayload) => {
    let json = await getGraphData(currentPayload);
    let graphType = currentPayload.GraphType;
    prepareData(json, currentPayload);
    const legends = [...new Set(json.map((item) => item.Description))];
    const xAxis = [...new Set(json.map((item) => item.DateTime))];
    let series = legends.map((xAxisName) => {
      let data = json
        .filter((e) => e.Name === xAxisName)
        .map((jsonData) => jsonData.Value);
      return {
        name: xAxisName,
        type: graphType,
        data
      };
    });
    let option = {
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        // data: legends
        // icon:'roundRect'
      },      
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      toolbox: {
        feature: {
          myTool1: {
            show: true,
            title: 'custom extension method 1',
            icon: 'path://M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8 a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z',
            onclick: () => {
              if (reportName) {
                downLoadExcel(reportName); 
              } else {
                console.error('reportName is not defined ');
              }
            }
          },
          saveAsImage: {}
        }
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: xAxis
      },
      yAxis: {
        type: 'value'
      },
      series: series
    };
    setOption(option);
  };
  const prepareData = async (json,trendData) => {
    let option = getOption();
    let xaxis = [];
    let series = [];
    let reportData = json &&
    Array.isArray(json) &&json.map((data) => ({
      ...data,
      DateTime: dayjs.utc(data.DateTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm')
    }));
    let ReportName = await getReportNametoDownload(
      reportData,
      trendData.Type,
      { fromDate, toDate },
      { fromDate, toDate },
      { fromDate, toDate }
    );
    setReportName(ReportName && ReportName.file ? ReportName.file : '');
      json &&
      Array.isArray(json) &&
      json.map((data) => {
      data = {
        ...data,
        DateTime: dayjs.utc(data.DateTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm')
      };
      if (!xaxis.includes(data.DateTime)) {
        xaxis.push(data.DateTime);
      }
      if (series.map((data) => data.name).includes(data.Name)) {
        let index = series.map((data) => data.name).indexOf(data.Name);
        if (codeType === 'Device') {
          series[index].data.push([
            data.DateTime,
            data.Value,
            data.Description,
            data.ParameterName,
            data.DeviceName
          ]);
        } else {
          series[index].data.push([
            data.DateTime,
            data.Value,
            data.Description,
            data.ParameterName,
            data.AssetName
          ]);
        }
      } else {
        let obj = {};
        if (codeType === 'Device') {
          obj = {
            name: data.Name,
            data: [
              [data.DateTime, data.Value, data.Description, data.ParameterName, data.DeviceName]
            ],
            type: graphType && graphType !== 'Area' ? graphType : 'line',
            ...(graphType && graphType === 'Area' ? { areaStyle: {} } : {})
          };
        } else {
          obj = {
            name: data.Name,
            data: [
              [data.DateTime, data.Value, data.Description, data.ParameterName, data.AssetName]
            ],
            type: graphType && graphType !== 'Area' ? graphType : 'line',
            ...(graphType && graphType === 'Area' ? { areaStyle: {} } : {})
          };
        }
        series.push(obj);
      }
      return {};
    });
    option.xAxis.data = xaxis;
    option.series = series;
    setOption(option);
  };
  const getOption = () => {
    // let { graphType } = this.state;
    let option = {
      legend: {
        icon: 'roundRect'
      },
      tooltip: {
        trigger: 'axis'
      },
      toolbox: {
        showTitle: false,
        orient: 'horizontal',
        itemSize: 15,
        feature: {
          myTool1: {
            show: true,
            title: 'custom extension method 1',
            icon: 'path://M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z',
            onclick: () => {
              if (reportName) {
                downLoadExcel(reportName); 
              } else {
                console.error('reportName is not defined ');
              }
            }
          },
          saveAsImage: {}
        }
      },
      xAxis: {
        type: 'category',
        data: []
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          data: [],
          type: 'line'
        }
      ]
    };
    return option;
  };  
  const downLoadExcel = (file) => {
    const link = document.createElement('a');
    link.href = `${IPAddress.LOCAL}${REPORTS.Reports}/${file}`;
    link.setAttribute('download', file);
    document.body.appendChild(link);
    link.click();
  };
  const getReportNametoDownload = async (excelData, Type, SelectedDate) => {
    let payload = {
      PortName: 'Rubus',
      Name: Type || 'Trend',
      Consumption: 'Trend',
      Data: excelData || [],
      ReportType: 'singleHierarchy',
      GeneratedDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      SelectedDate: `${dayjs.utc(SelectedDate.fromDate).format('YYYY-MM-DD HH:mm')}~${dayjs.utc(SelectedDate.toDate).format('YYYY-MM-DD HH:mm')}`,
      SelectionType: 'dateRange'
    };
    let siteId = localStorage.get('currentSite');
    let accessToken = localStorage.get('accessToken');
    let options = {
      method: 'POST',
      url: `${API_FILE.GenerateExcel}?SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: JSON.stringify(payload)
    };
    try {
      const { data } = await axios(options);
      return data;
    } catch {
      return '';
    }
  };
  const onChangeFromDate_ToDate1 = (selectedFromDate_ToDate1) => {
    let updatedPayload = {
      ...payload,
      FromDate: dayjs(selectedFromDate_ToDate1[0]).utc().format('YYYY-MM-DD HH:mm:ss'),
      ToDate: dayjs(selectedFromDate_ToDate1[1]).utc().format('YYYY-MM-DD HH:mm:ss')
    };
    generateData(updatedPayload);
    setPayload(updatedPayload);
  };
  const onIntervalChange = async (Interval) => {
    let updatedPayload = {
      ...payload,
      Interval
    };
    if (payload.GraphType !== 'Table') {
      generateData(updatedPayload);
    } else {
      let json = await getGraphData(updatedPayload);
      setPayload(updatedPayload);
      // setSelectedInterval(Interval);
      setJson(json);
    }
    setPayload(updatedPayload);
    // setSelectedInterval(Interval);
  };
  const onCheckboxChange = async (Operator) => {
    let updatedPayload = {
      ...payload,
      Operator
    };
    if (payload.GraphType !== 'Table') {
      generateData(updatedPayload);
    } else {
      let json = await getGraphData(updatedPayload);
      setPayload(updatedPayload);
      setSelectedOperators(Operator);
      setJson(json);
    }
  // let { payload } = this.state;
    // payload = {
    //   ...payload,
    //   Operator//   // let { selectedOperators } = this.state;
    //   let { payload } = this.state;
    //   payload = {
    //     ...payload,
    //     Operator
    //   };
    //   this.generateData(payload);
    //   this.setState({ payload, selectedOperators: Operator });
    //   // if (e.target.checked === true) {
    //   //   this.setState({ selectedOperators: e.target.value });
    //   //   let { payload } = this.state;
    //   //   payload = {
    //   //     ...payload,
    //   //     Operator: e.target.value
    //   //   };
    //   //   this.setState({ payload });
    //   //   this.generateData(payload);
    //   // }
    //   // else if(e.target.checked === false)
    //   // {
    //   //   // let data = checkedArray.filter((val) => val !== e.target.value);
    //   // //   this.setState({ checkedArray: data });
    //   // //   this.props.handleDropdownChange(data);
    //   // }
    //   // if (e.target.checked === true) {
    //   //   checkedArray.push(e.target.value);
    //   //   this.setState({ checkedArray });
    //   //   this.props.handleDropdownChange(checkedArray);
    //   // } else if (e.target.checked === false) {
    //   //   let data = checkedArray.filter((val) => val !== e.target.value);
    //   //   this.setState({ checkedArray: data });
    //   //   this.props.handleDropdownChange(data);
    //   // }
    // };
    // };
    // this.generateData(payload);
    // this.setState({ payload, selectedOperator: Operator });
  };
  const radioOnChange = async (e) => {
    let GraphType = e.target.value;
    if (GraphType !== 'Table') {
      let updatedPayload = {
        ...payload,
        GraphType
      };
      generateData(updatedPayload);
      setPayload(updatedPayload);
      setGraphType(GraphType);
    } else {
      let updatedPayload = {
        ...payload,
        GraphType
      };      
      let json = await getGraphData(updatedPayload);
      setPayload(updatedPayload);
      setGraphType(GraphType);
      setJson(json);
    }
  };
  const onShareTypeChange = (value) => {
    setSelectedShareType(value);
  };
  const onObservationSave = async () => {
    let name = '';
    if (codeType === 'Device') {
      name =
        selectedName &&
        selectedName[0] &&
        selectedName[0].DeviceName &&
        selectedName[0].DeviceName[0];
    } else {
      name =
        selectedName &&
        selectedName[0] &&
        selectedName[0].AssetName &&
        selectedName[0].AssetName[0];
    }
    observeRef.current.validateFields()
      .then(async (values) => {
        let observationPayload = {
          ...values,
          DateTime: celd.data[0],
          Parameter: celd.data[3],
          Device: celd.data[4],
          Operator: 'AVG',
          Type: codeType,
          Code: name
        };
        let response = await CreateObservation(observationPayload);
        if (response?.message) {
          message.success(translation(response.message));
          observeRef.current.resetFields();
          let observations = await getObservationList();
          // setObservationList(observations);
          setVisible(false);
          setSelectedShareType('');
          props.ObservationList(observations);
        } else if (response?.Error) {
          message.error(translation(response.Error));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const onObservationCancel = () => {
    observeRef.current.resetFields();
    setVisible(false);
    setSelectedShareType('');
  };
  const onChartClick = (cellData) => {
    setCeld(cellData);
    setVisible(true);
  };
  const translation = (keyword) => {
    return translationCache[keyword] || keyword;
  };
  const disabledDate = (current) => {
    return current > dayjs().startOf('day').add(1, 'day');
  };
    let onEvents = {
      click: (cellData) => onChartClick(cellData)
    };
    return (
      <>
        {/* <div style={{ margin: '5px 0px', display: 'flex', justifyContent: 'flex-end' }}>
          {constants &&
            Array.isArray(constants.operatorList) &&
            constants.operatorList &&
            constants.operatorList.map((operator, index) => {
              return (
                <Checkbox
                  key={operator.label}
                  // value={operator}
                  defaultValue={selectedOperators}
                  checked={operator.value === selectedOperators}
                  onChange={(e) => this.onCheckboxChange(e, index)}
                >
                  {operator.label}
                </Checkbox>
              );
            })}
        </div> */}
        <div>
          <RangePicker
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
            style={{ width: '330px' }}
            placeholder={[translation('Start DateTime'), translation('End DateTime')]}
            value={[fromDate, toDate]}
            onChange={onChangeFromDate_ToDate1}
            disabledDate={disabledDate}
          />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0px' }}>
          <Radio.Group onChange={radioOnChange} value={graphType}>
            <Radio.Button value={'line'}>{translation('Line')}</Radio.Button>
            <Radio.Button value={'bar'}>{translation('Bar')}</Radio.Button>
            <Radio.Button value={'Area'}>{translation('Area')}</Radio.Button>
            <Radio.Button value={'Table'}>{translation('Table')}</Radio.Button>
          </Radio.Group>
          {payload && payload.Type === 'historic' && (
            <>
              <Select
                showSearch
                style={{ width: 100 }}
                value={payload.Interval}
                placeholder={translation('Select Interval')}
                onChange={onIntervalChange}
                options={frequencyList}
          />
              <Select
                showSearch
                style={{ width: 100 }}
                value={selectedOperators}
                placeholder={translation('Select Operator')}
                onChange={onCheckboxChange}
              >
                {operatorList &&
                  Array.isArray(operatorList) &&operatorList.map((Operator, index) => (
                  <Option key={index} value={Operator.Key}>
                    {Operator.Value}
                  </Option>
                ))}
              </Select>
            </>
          )} 
          {/* <Select
            // showSearch
            defaultValue={SelectedInterval}
            placeholder="Select interval"
            onChange={this.onIntervalChange}
            // onSearch={onSearch}
            // filterOption={filterOption}
            options={[
              {
                value: '1m',
                label: '1m'
              },
              {
                value: '1h',
                label: '1h'
              }
            ]}
          /> */}
          </div>
          {graphType === 'Table' ? (
          <TableComponent
            panelData={{
              graph: 'trends',
              trendData: json,
              colors: color,
              GraphType :graphType
            }}
            currentTimeZone={props.currentTimeZone}
            className="trendTable"
            dataSource={json}
          />
          ) : (
          <ReactEcharts
            option={option}
            notMerge={true}
            lazyUpdate={true}
            onEvents={payload.Type === 'historic' ? onEvents : null}
            style={{ height: '80%', width: '100%' }}
            className="react_for_echarts"
            theme="light"
          />
          )}
          <Modal
          title={translation('Observation List')}
          open={visible}
          onOk={onObservationSave}
          onCancel={onObservationCancel}
          footer={[
            <Button key="back" onClick={onObservationCancel}>
              {translation('Cancel')}
            </Button>,
            <Button key="submit" type="primary" onClick={onObservationSave}>
              {translation('Save')}
            </Button>
          ]}
          >
          <Form ref={observeRef} layout="vertical">
            <Form.Item
              name={'Name'}
              label={translation(constant.ObservationName)}
              rules={[{ required: true, message: translation('Input Observation!') }]}
            >
              <Input
                placeholder={translation('Please Input Observation Name')}
                // onChange={(e) => setObservationsName(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              name={'Comments'}
              label={translation(constant.ObservationFeedback)}
              rules={[{ required: true, message: translation('Input Observation Feedback!') }]}
            >
              <Input
                placeholder={translation('Please Input Observation Feedback')}
                // onChange={(e) => setObservationsFeedback(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              name={'ShareType'}
              label={translation(constant.ShareType)}
              rules={[{ required: true, message: translation('Please select ShareType!') }]}
            >
              <Select
                placeholder={translation('Please select ShareType')}
                onChange={onShareTypeChange}
              >
                <Option value="Public">{translation('Public')}</Option>
                <Option value="Private">{translation('Private')}</Option>
                <Option value="Group">{translation('Group')}</Option>
              </Select>
            </Form.Item>
            {selectedShareType === 'Group' && (
              <Form.Item
                name={'ShareUsers'}
                label={translation(constant.ShareUsers)}
                rules={[{ required: true, message: translation('Please select ShareUser !') }]}
              >
                <Select
                  placeholder={translation('Please select ShareUser ')}
                >
                  {UsersList &&
                  Array.isArray(UsersList) &&UsersList.map((user, index) => (
                    <Option key={index} value={user.UserName}>
                      {user.UserName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}
          </Form>
          </Modal>
      </>
    );
};
const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  currentTimeZone: state.LayoutReducer.currentTimeZone
});
export default connect(mapStateToProps)(AllGraphView);
